import { useCallback, useState } from "react"
import { useAppContext } from "~/app.use-app-context.hook"
import {
  isLoading,
  match,
  withFailure,
  withSuccess,
} from "~/store/async-store.utils"
import { Region } from "./region.model"

type State = {
  regions: Region[]
  isLoading: boolean
  error: string | null
}

export function useRegionsStore() {
  const {
    regionsModule: { service, store },
  } = useAppContext()
  const [state, setState] = useState<State>({
    regions: withSuccess(store.state, [], ({ regions }) => regions),
    isLoading: isLoading(store.state),
    error: withFailure(store.state, null, (error) => error),
  })

  store.addListener(
    match({
      onInitial: () => {
        setState({
          regions: [],
          isLoading: false,
          error: null,
        })
      },
      onLoading: () => {
        setState({ ...state, isLoading: true })
      },
      onFailure: (error) => {
        setState({ ...state, error, isLoading: false })
      },
      onSuccess: ({ regions }) => {
        setState({ regions, isLoading: false, error: null })
      },
    }),
  )

  const fetchRegions = useCallback(async () => {
    await service.fetchAll()
  }, [service])

  return {
    state,
    actions: { fetchRegions },
  }
}
